import React from "react";

import { useTheme } from "../../../utils/Theme";

import { SVGProps } from "./SVG.props";

const Add = (props: SVGProps): JSX.Element => {
  const theme = useTheme();
  const { width, height, fill } = props;

  // Paste converted svg below
  // https://react-svgr.com/playground/?typescript=true
  return (
    <svg
      width={width || 16}
      height={height || 16}
      viewBox="0 0 16 16"
      fill={fill || "black"}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.625 8.12354H8.125V8.62354V11.7485C8.125 11.7817 8.11183 11.8135 8.08839 11.8369C8.06495 11.8604 8.03315 11.8735 8 11.8735C7.96685 11.8735 7.93505 11.8604 7.91161 11.8369C7.88817 11.8135 7.875 11.7817 7.875 11.7485V8.62354V8.12354H7.375H4.25C4.21685 8.12354 4.18505 8.11037 4.16161 8.08692C4.13817 8.06348 4.125 8.03169 4.125 7.99854C4.125 7.96538 4.13817 7.93359 4.16161 7.91015C4.18505 7.8867 4.21685 7.87354 4.25 7.87354H7.375H7.875V7.37354V4.24854C7.875 4.21538 7.88817 4.18359 7.91161 4.16015C7.93505 4.1367 7.96685 4.12354 8 4.12354C8.03315 4.12354 8.06495 4.1367 8.08839 4.16015C8.11183 4.18359 8.125 4.21538 8.125 4.24854V7.37354V7.87354H8.625H11.75C11.7832 7.87354 11.8149 7.88671 11.8384 7.91015C11.8618 7.93359 11.875 7.96538 11.875 7.99854C11.875 8.03169 11.8618 8.06348 11.8384 8.08692C11.8149 8.11037 11.7832 8.12354 11.75 8.12354H8.625Z"
        fill={fill || "black"}
        stroke={fill || "black"}
      />
    </svg>
  );
};

export default Add;
